import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import * as $ from "jquery";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
/**
 * View Model for the Person Tab in QualificationView
 */
class QualificationPerson extends GenericListSearchTab {

    // #region Constructor

    /**
     * Constructor
     * @param tabPage
     * @param parent
     */
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.Models.subscribe(() => this.Selection([]));
    }

    // #endregion Constructor

    // #region Properties

    /**
     * ToolbarClick Property
     * @param button
     * @returns
     */
    ToolbarClick = (button: Interfaces.Bao.BaoMenuItem) => this.CustomToolbarClick(button);

    // #endregion Properties

    // #region Methods

    /**
     *  Overridden basic function to set searchType
     * @returns
     */
    SearchType(): string { return "Person"; }

    /**
     * Overridden basic function ItemCompleteCheck
     * @param item
     * @returns
     */
    ItemCompleteCheck(item): JQueryPromise<boolean> {
        const def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }

    /**
     * Overridden basic function to support custom filters
     * @returns
     */
    CustomFilter(): Models.HashObject[] { return null; }

    // #endregion Methods

}
export default QualificationPerson;